// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthPage_container__WV-ci","formWrapper":"AuthPage_formWrapper__2_dJa","bottomRight":"AuthPage_bottomRight__1qhVU"};